

export default () => {
  // $('a').not('.p-post__next-page-link').on('click',(e)=>{
  //   const $this = $(e.currentTarget);
  //   let menuDiff = '';
  //   if($this.closest('.p-post__index').length){
  //     console.log('p-post__index')
  //     menuDiff = 130;
  //   }
  //   if($this.attr('href')){
  //     const href = $this.attr('href');
  //     const hash = href.split("#");
  //     if($this.attr('data-target')==='pagetop'){
  //       $("html, body").animate({scrollTop:0}, 500, 'swing');
  //       return false;
  //     } else if(href.indexOf("#") != -1){
  //       const $target = $('#' + hash[hash.length - 1]);
  //       const position = $target.offset().top - menuDiff;

  //       $.when(
  //         $("html, body").animate({
  //           scrollTop: position
  //         }, 500, 'swing'),
  //         e.preventDefault(),
  //       ).done(function() {
  //         setTimeout( ()=>{
  //           var diff = $target.offset().top - menuDiff;
  //           if (diff === position) {
  //           } else {
  //             $("html, body").animate({
  //               scrollTop: diff
  //             }, 100, 'swing');
  //           }
  //         }, 100)
  //       });
        
  //     }
  //   }
  // })
}